<template>
  <div id="app">
    <cc-nav-bar v-show="shouldShowNavigation"></cc-nav-bar>
    <div class="">
      <cc-alerts></cc-alerts>
      <router-view></router-view>
    </div>
    <footer-bar v-show="shouldShowNavigation"></footer-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CcNavBar from './components/root/navbar'
import CcAlerts from './components/general/alerts'
import FooterBar from './components/root/footer'

export default {
  name: 'HeltOpplagt',
  components: {
    CcNavBar,
    CcAlerts,
    FooterBar,
  },
  computed: {
    ...mapGetters(['shouldShowNavigation']),
  },

}
</script>

<style lang="sass" src="assets/sass/app.scss"></style>



// WEBPACK FOOTER //
// Root.vue?39d5c8a8